import { render, staticRenderFns } from "./TedSection.vue?vue&type=template&id=143a3778&scoped=true"
import script from "./TedSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TedSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TedSection.vue?vue&type=style&index=0&id=143a3778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a3778",
  null
  
)

export default component.exports